'use strict';

function formatResumoFinanceiro(contrato) {

  if (contrato.financialSummary && contrato.financialSummary.length) {
    const totalResumoFinanceiro = contrato.financialSummary.find(resumo => resumo.nuAno === 0);

    const resumoFinanceiro = contrato.financialSummary.filter(resumo => resumo.nuAno !== 0);

    return { totalResumoFinanceiro, resumoFinanceiro };
  }

  return {
    resumoFinanceiro: [],
    totalResumoFinanceiro: null,
  }
}

function DetailsController($rootScope, $scope, appSettings, objectMakerFactory, dataHolderFactory, printerService, parameterFactory, parameterNames, constantSettings, usSpinnerService, dataRequestService) {
  const self = this;

  this.configureContractListInformation = function(viewControl) {
    viewControl.hasFinancier = parameterFactory.getParameter(parameterNames.PRM_SHOW_INFO_FINANCIAL).value === "S";
    viewControl.showPaidChart = viewControl.hasFinancier && appSettings.config.show.paidChart;
    viewControl.showGraficoPagoPorcentagem = viewControl.hasFinancier && appSettings.config.show.graficoPagoPorcentagem;
    viewControl.showGraficoContratadoComExecutado = appSettings.config.show.graficoContratadoComExecutado;
    viewControl.showPhysicalPercentage = appSettings.config.show.physicalPercentage;
    viewControl.showFinancialPaid = appSettings.config.show.financialPaid;
    viewControl.showDetailsContract = appSettings.config.show.detailsContract;
    viewControl.showFiscalLinks = appSettings.config.show.fiscalLinks;
    viewControl.showInfoValorPago = appSettings.config.show.infoValorPago;
    viewControl.showPortalDocumentos = appSettings.config.show.portalDocumentos;

    const contratoDetalhes = appSettings.config.contratoDetalhes || {};

    let contrato = dataHolderFactory.getSavedContractDetails();

    const { resumoFinanceiro, totalResumoFinanceiro } = formatResumoFinanceiro(contrato);

    contrato.resumoFinanceiro = resumoFinanceiro;
    contrato.totalResumoFinanceiro = totalResumoFinanceiro;

    viewControl.contract = contrato;

    console.log({ contract: viewControl.contract })
    viewControl.informacoesGerais = objectMakerFactory.viewObjectForInformacoesGerais(contrato, viewControl.showDetailsContract, contratoDetalhes.informacoesGerais);
    viewControl.informacoesPrazos = objectMakerFactory.viewObjectForInformacoesPrazos(contrato, contratoDetalhes.informacoesPrazos);
    viewControl.informacoesFinanceiras = objectMakerFactory.viewObjectForInformacoesFinanceiras(contrato, viewControl.hasFinancier, viewControl.showFinancialPaid, contratoDetalhes.informacoesFinanceiras);
    $scope.showBotaoDetalhes = !$.isEmptyObject(appSettings.config.contratoDetalhes);

    if (!contrato.covenant) {
      viewControl.showEdict = appSettings.config.show.edict;
      viewControl.showLicencesEnvironmental = appSettings.config.show.licencesEnvironmental;
    }

    const zerarValorMenorQue1 = (property) => {
      viewControl.contract[property] = viewControl.contract[property] >= 1 ? viewControl.contract[property] : 0;
    };

    zerarValorMenorQue1('peContractedAmount');
    zerarValorMenorQue1('peExecutedAmount');
    zerarValorMenorQue1('pePaidAmount');
    zerarValorMenorQue1('pePhysicalPercentage');

    viewControl.contract.peContractedAmountS = { width: viewControl.contract.peContractedAmount + '%' };
    viewControl.contract.peContractedAmountL = { 'margin-left': viewControl.contract.peContractedAmount + '%' };
    viewControl.contract.peExecutedAmountS = { width: viewControl.contract.peExecutedAmount + '%' };
    viewControl.contract.peExecutedAmountL = { 'margin-left': viewControl.contract.peExecutedAmount + '%' };
    viewControl.contract.pePaidAmountS = { width: viewControl.contract.pePaidAmount + '%' };
    viewControl.contract.pePaidAmountL = { 'margin-left': viewControl.contract.pePaidAmount + '%' };
    viewControl.contract.pePhysicalPercentageS = { width: viewControl.contract.pePhysicalPercentage + '%' };
    viewControl.contract.pePhysicalPercentageL = { 'margin-left': viewControl.contract.pePhysicalPercentage + '%' };

  };

  $scope.selectedContract = function(contractId) {
    if ($rootScope.appControl.currentContract === contractId) {
      return;
    }
    $rootScope.appControl.showDetailsBox = false;
    $rootScope.appControl.showFloatingControl = false;
    self.getDetailsForContract(contractId);
  };

  this.getDetailsForContract = function(contractId) {
    usSpinnerService.spin('spinner-1');
    dataRequestService.getContractDetails(contractId).then(function(result) {
      usSpinnerService.stop('spinner-1');
      $rootScope.appControl.currentContract = contractId;
      dataHolderFactory.updateContractDetails(result);
      $rootScope.appControl.showDetailsBox = true;
      $rootScope.$emit('didSelectContract', result.id);
    }, function(error) {
      usSpinnerService.stop('spinner-1');
      console.log(error);
    });
  };

  $scope.initDetailsController = function() {
    $scope.detailsViewControl = objectMakerFactory.viewObjectControlForDetails();
    self.configureContractListInformation($scope.detailsViewControl);
  };

  $scope.getFotoCapa = function() {
    const imagens = angular.copy($scope.detailsViewControl.contract.mainImages);
    let fotoCapa = angular.copy(imagens[0].img);

    angular.forEach(imagens, function(imagem) {
      if (imagem.fotoCapa) {
        fotoCapa = imagem.img;
      }
    });

    return fotoCapa;
  };

  $scope.showOnMap = function(construction) {
//		if(!$rootScope.appControl.showFilterBox) { return; }
    $rootScope.appControl.showFilterBox = false;
    $rootScope.$emit('showingOnMap', construction);
  };

  $scope.restoreViewControl = function() {
    if ($rootScope.appControl.showingInMap) {
      $rootScope.$emit('openViewWithContext', 'CONTRACTS');
      $rootScope.appControl.showDetailsBox = false;
      $rootScope.appControl.showSpecificDetailBox = false;
      return;
    }
    $scope.detailsViewControl.contract = null;
    $rootScope.appControl.currentContract = '';
    $rootScope.appControl.showDetailsBox = false;
    $rootScope.appControl.showFloatingControl = true;
    $rootScope.$emit('cleanMarkersOpacity');
    dataHolderFactory.updateContractDetails(null);
    $rootScope.appControl.showSpecificDetailBox = false;
  };

  $scope.restoreViewControlSpeficicBox = function() {
    $rootScope.appControl.showSpecificDetailBox = false;
  };

  $scope.showEdict = function() {
    if ($rootScope.appControl.showEdict) {
      return;
    }
    $rootScope.appControl.showEdict = true;
  };

  $scope.showLicencesEnvironmental = function() {
    if ($rootScope.appControl.showLicencesEnvironmental) {
      return;
    }
    $rootScope.appControl.showLicencesEnvironmental = true;
  };

  $scope.showSupervisors = function(siteId) {
    if ($rootScope.appControl.showConstructionSiteSupervisorsBox) {
      return;
    }
    dataHolderFactory.updateCurrentSiteId(siteId);
    $rootScope.appControl.showConstructionSiteSupervisorsBox = true;
  };

  $scope.showMorePhotos = function(mapFotos) {
    if ($rootScope.appControl.showAlbumBox) {
      return;
    }
    dataHolderFactory.updateMapAlbumPhotos(mapFotos);
    $rootScope.appControl.showAlbumBox = true;
  };

  $scope.sendEmail = function() {
    
    if ($rootScope.appControl.showEmailBox) {
      return;
    }

    let details = $scope.detailsViewControl;
    let infoGerais = objectMakerFactory.viewObjectForInformacoesGerais(details.contract, details.showDetailsContract);
    let infoFinanceiras = objectMakerFactory.viewObjectForInformacoesFinanceiras(details.contract, details.hasFinancier, details.showFinancialPaid);
    let infoPrazos = objectMakerFactory.viewObjectForInformacoesPrazos(details.contract);
    dataHolderFactory.updatePdfDataUri(printerService.pdfPrintingForContractDetails(true, $scope.detailsViewControl.contract, infoGerais, infoPrazos, infoFinanceiras));
    //dataHolderFactory.updatePdfDataUri(this.printPDF(true));
    $rootScope.appControl.showEmailBox = true;
  };

  $scope.showDetail = function(detalhe, titulo) {
    if ($rootScope.appControl.showSpecificDetailBox) {
      return;
    }
    dataHolderFactory.updateDetailInfo(detalhe, titulo);
    let detailInfo = dataHolderFactory.getDetailInfo();
    $scope.currentTitulo = detailInfo.titulo;
    $scope.currentDetalhe = detailInfo.detalhe;
    $rootScope.appControl.showSpecificDetailBox = true;
  };

  $scope.redirecionarPortalDocumentos = function(){
    window.open(location.origin + '/portal-documentos/#/' +  appSettings.getSource() + '/' + $scope.detailsViewControl.contract.id + '/documentos', '_blank');
  }

  $scope.redirecionarPortalDocumentosNovo = function(){
    $scope.$emit('setGoogleAnalyticsData',constantSettings.actionPortal + $scope.detailsViewControl.contract.id);
    window.open(location.origin + '/obrasgov-portal-documentos/#/' + appSettings.getSource() + '/' + $scope.detailsViewControl.contract.id + '/documentos', '_blank');
  }

  $scope.printPDF = function(isEmail) {
    $scope.$emit('setGoogleAnalyticsData',constantSettings.actionReportContractDetailed + $scope.detailsViewControl.contract.id);
    let details = $scope.detailsViewControl;
    let infoGerais = objectMakerFactory.viewObjectForInformacoesGerais(details.contract, details.showDetailsContract);
    let infoFinanceiras = objectMakerFactory.viewObjectForInformacoesFinanceiras(details.contract, details.hasFinancier, details.showFinancialPaid);
    let infoPrazos = objectMakerFactory.viewObjectForInformacoesPrazos(details.contract);
    printerService.pdfPrintingForContractDetails(isEmail, $scope.detailsViewControl.contract, infoGerais, infoPrazos, infoFinanceiras);
  };

  $scope.printODTContratoDetalhado = async function() { 

    $scope.$emit('setGoogleAnalyticsData',constantSettings.actionReportEditableContract+$scope.detailsViewControl.contract.id);
    usSpinnerService.spin('spinner-1');    
    $scope.disabledBtOdtContratoDetalhado = true;   
 
    dataRequestService.getContractReportData($scope.detailsViewControl.contract.id)
      .then(function(response) {

          usSpinnerService.stop('spinner-1');

          if (!response.data) {
            console.error('No file data received');
            return;
          }
      
          var contentType = response.headers('Content-Type') || 'application/octet-stream';
          var blob = new Blob([response.data], { type: contentType });
          var url = window.URL.createObjectURL(blob);
        
          var a = document.createElement('a');
          a.href = url;
          a.download = 'relatorio.odt';
          document.body.appendChild(a);
          a.click();

          $scope.disabledBtOdtContratoDetalhado = false;

        }, function(error) {
          console.error('Download failed:', error);
        });
  };

  $scope.showDetalhes = function(e) {
    let idDiv = angular.element(e.currentTarget).attr("id");
    let configExibicao = appSettings.config.contratoDetalhes[idDiv];
    if (!objectMakerFactory.isConfigExibicaoContratoDetalhesValidos(configExibicao)) {
      return;
    }

    let detalhes = $scope.detailsViewControl[idDiv];
    detalhes.forEach(function(detalhe) {
      if (configExibicao.opcionais.includes(detalhe.label)) {
        detalhe.render = !detalhe.render;
      }
    })
  };
}

DetailsController.$inject = ['$rootScope', '$scope', 'appSettings', 'objectMakerFactory', 'dataHolderFactory', 'printerService', 'parameterFactory', 'parameterNames', 'constantSettings', 'usSpinnerService', 'dataRequestService'];
export default DetailsController



// WEBPACK FOOTER //
// ./src/app/scripts/controllers/detailsController.js